import {
  getEntrepreneursCubeDimensionValues
} from "./get-entrepreneurs-cube-dimension-values";

export const getEntrepreneursCampusList = () => {
  return getEntrepreneursCubeDimensionValues("teamMemberCampus");
};
